import React from 'react';

const ErrorNotification = () => {
  return (
    <div className="w-full p-4 bg-red-500/20 border border-red-500 rounded-xl mb-4">
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
        <div className="ml-3">
          <h3 className="text-lg font-medium text-red-500">Prediction system error</h3>
          <div className="mt-2 text-sm text-gray-300">
            <p>
              An error occurred while loading prediction data. Please try again later or contact support if the problem persists.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorNotification;
